<!--
 * @Description: 
 * @Author: kangkang
 * @Date: 2023-04-01 20:59:40
 * @LastEditTime: 2023-04-08 22:06:17
 * @LastEditors: kangkang
 * @Reference: 
-->
<template>
    <div id="app">
        <router-view />
    </div>
</template>

<style lang="scss">
html,body,#app {
    height: 100%;

}
*{font-family:PingFangSC-Regular;}
@import "style/common/reset.css";
@import "style/common/layout";
@import "style/common/text";
@import "style/common/button";
@import "style/common/bg";
</style>
<script>
export default {
    data() {
        return {
            
        };
    },
    created() {
        
    },
    methods: {

    },
    watch: {
        
    }
};
</script>

